import React from 'react';

export const IconDeviceBlindMotor: React.FC = () => (
  <svg width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.290039" y="0.859375" width="56" height="56" rx="12" fill="white" />
    <g clipPath="url(#clip0_23108_24181)">
      <path
        d="M14.2664 31.7346V37.8591H10.2675V26.7584M14.2664 31.7346V21.7822M14.2664 31.7346V31.7346C15.1237 33.5871 17.7427 33.6267 18.6555 31.801L18.6887 31.7346M18.6887 31.7346V21.7822M18.6887 31.7346V34.863H42.0967V33.0267H42.6842V30.7314M18.6887 21.7822V18.566H42.0967V20.1728H42.6842V22.6977M18.6887 21.7822L18.663 21.7222C17.8271 19.7717 15.0488 19.8096 14.2664 21.7822V21.7822M14.2664 21.7822V15.6577H10.2675V26.7584M42.6842 22.6977H46.6227V30.7314H42.6842M42.6842 22.6977V30.7314M10.2675 26.7584C8.4174 28.3239 5.6564 30.5157 5.998 25.0507C6.4249 18.2195 0.84039 11.3712 -4.71 14.3599"
        stroke="#15141D"
        strokeWidth="1.28085"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    
  </svg>
);
